import React from 'react'
import { ChevronRight } from '@dasa-health/alma-icons'
import { Container, MainContainer, IconContainer, UnicoButton, Title, Text, Cta, Icon } from './styles'

import IconUnico3 from 'assets/face-scan-icon.svg'
import { SelectContactInitial } from 'components/Presenters/SelectContact'
import { ContactType } from 'typings'

type ValueTypes = {
    id: number | undefined
    value: string
    type: string
}

type UnicoSessionProps = {
    preHandleSubmit: (values: SelectContactInitial) => void
    isSubmitting?: boolean
}

export function UnicoSession({ preHandleSubmit, isSubmitting }: UnicoSessionProps) {
    const contactTypeValue = { id: undefined, value: 'unico', type: ContactType.UNICO }
    const contactType = { contact: { ...contactTypeValue } }

    function handleClick() {
        if (isSubmitting) {
            return
        }
        preHandleSubmit(contactType)
    }

    return (
        <Container>
            <UnicoButton data-testid="unico-button" isSubmitting={isSubmitting ?? false} onClick={handleClick}>
                <IconContainer>
                    <Icon alt="Ícone Único" src={IconUnico3} />
                </IconContainer>
                <MainContainer>
                    <Title>Sem acesso aos contatos indicados acima?</Title>
                    <Text>Cadastre agora um novo contato e valide com o reconhecimento facial.</Text>
                    <Cta isSubmitting={isSubmitting ?? false}>
                        Cadastrar novo contato <ChevronRight fontSize={24} style={{ marginLeft: 8 }} />
                    </Cta>
                </MainContainer>
            </UnicoButton>
        </Container>
    )
}
